import {atomWithRefresh} from "../utils/jotaiUtils";
import {routerCompanyIdAtom, routerFieldIdAtom} from "./routerStore";
import {getScoutingNotes} from "../services/scoutingNotesService";
import {loadable} from "jotai/utils";

export const activeScoutingNotesAtom = atomWithRefresh(async (get) => {
    const activeCompanyId = get(routerCompanyIdAtom);
    const activeFieldId = get(routerFieldIdAtom);
    const results =
        activeCompanyId !== undefined && activeFieldId !== undefined
            ? await getScoutingNotes(activeCompanyId, activeFieldId)
            : [];

    return results;
});

export const activeScoutingNotesAtomLoadable = loadable(activeScoutingNotesAtom);
